<template>
    <!-- <div class="layout-topbar"> -->
    <div class="p-mb-2">
        <!-- <a class="layout-menu-button " href="#" @click="onMenuButtonClick">
            <i class="menuAll pi pi-bars"></i>
        </a> -->
        <div class="p-grid" style="margin: 0">
            <div class="p-col maxwidth">
                <img width="90" src="../public/assets/layout/images/logo_199.png" />
            </div>
            <!-- Doe แก้ไข Head 1/3 -->
            <div class="p-col p-col-8 p-lg-7" id="system-nameclass">
                <div id="head_name_menu" class="line">ระบบฐานข้อมูลสารสนเทศภูมิศาสตร์และระบบสารสนเทศการบริหารเพื่อการป้องกันและบรรเทาสาธารณภัย</div>
                <!-- Doe แก้ไข Head 1/3 จบ-->

                <div id="system-name">ระบบฐานข้อมูลสารสนเทศภูมิศาสตร์และระบบสารสนเทศการบริหาร</div>
                <div id="system-name" class="line">เพื่อการป้องกันและบรรเทาสาธารณภัย</div>
                <div id="system-name-org" class="p-mt-1">สำนักป้องกันและบรรเทาสาธารณภัย กรุงเทพมหานคร (สปภ. กทม.) : เวอร์ชั่น 2.7.0</div>
            </div>

            <!-- Doe แก้ไข Head 2/3-->
            <div id="Login_bar" class="LoginBar_" style="margin-left: auto">
                <div class="p-grid p-jc-end p-mt-2 p-mr-3 phone" style="margin-left: auto">
                    <ul class="layout-topbar-menu" id="Login_bar">
                        <p v-if="login_success == false" @click="loginModal = true" class="login-text pointer" id="login-texts">
                            <!-- {{ $t("LoginButton") }} -->
                        </p>

                        <p v-else @click="toggle" class="login-text pointer" id="login-texts">
                            {{ fullname }} ({{ position }})
                            <i class="pi pi-user" color="rgb(0,0,0)"></i>
                        </p>

                        <OverlayPanel ref="op" :showCloseIcon="false" appendTo="body" style="width: 250px">
                            <!-- <div>
              
            </div> -->

                            <Button
                                @click="$router.push('/update').catch((err) => {})"
                                label="รายการที่ต้องปรับปรุงข้อมูล"
                                class="p-button-info p-button-text"
                            />
                            <hr />
                            <!-- <center>
            <Button
            @click="logout()"
                        :label="$t('Logout')"
                        class="p-button-danger"
                      />
            </center> -->
                        </OverlayPanel>

                        <!-- Login modal -->
                        <Dialog :modal="true" :visible.sync="loginModal" :style="{ width: '350px' }" :header="$t('login_title')">
                            <div class="confirmation-content">
                                <label>{{ $t('login_subtitle') }}</label>
                                <div class="p-fluid p-mt-5">
                                    <div class="p-field">
                                        <label for="username">{{ $t('login_username') }}</label>
                                        <InputText
                                            id="username"
                                            type="text"
                                            v-model="username"
                                            required="true"
                                            autofocus
                                            :class="{ 'p-invalid': error_username && !username }"
                                        />
                                        <small class="p-invalid" v-if="error_username && !username">{{ $t('login_validate_username') }}</small>
                                    </div>
                                    <div class="p-field">
                                        <label for="password">{{ $t('login_password') }}</label>
                                        <InputText
                                            id="password"
                                            type="password"
                                            v-model="password"
                                            required="true"
                                            autofocus
                                            :class="{ 'p-invalid': error_password && !password }"
                                        />
                                        <small class="p-invalid" v-if="error_password && !password">{{ $t('login_validate_password') }}</small>
                                    </div>
                                    <small class="p-invalid" v-if="login_failed == true">{{ $t('login_invalid') }}</small>
                                </div>
                            </div>
                            <template #footer>
                                <Button :label="$t('cancelBtn')" icon="pi pi-times" class="p-button-text" @click="clearData()" />
                                <Button :label="$t('login_confirm')" icon="pi pi-check" class="p-button-text" @click="checkLogin()" />
                            </template>
                        </Dialog>

                        <!-- Are you sure for close this modal -->
                        <Dialog
                            :modal="true"
                            :header="$t('ConfirmCloseModal')"
                            :visible.sync="displayConfirmationCloseModal"
                            :style="{ width: '350px' }"
                        >
                            <div class="confirmation-content p-mt-3">
                                <span>{{ $t('ConfirmCloseModalSub') }}</span>
                            </div>
                            <template #footer>
                                <Button
                                    :label="$t('cancelBtn')"
                                    icon="pi pi-times"
                                    @click="displayConfirmationCloseModal = false"
                                    class="p-button-text"
                                />
                                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="closeAllModal()" class="p-button-text" autofocus />
                            </template>
                        </Dialog>
                    </ul>
                </div>
                <a class="layout-menu-button" href="#" @click="onMenuButtonClick" id="Login_bar_menu" style="margin-right: 1rem">
                    <i class="menuAll pi pi-bars"></i>
                </a>
            </div>
            <!-- Doe แก้ไข Head 2/3 จบ-->
        </div>
    </div>

    <!-- </div> -->

    <!-- old -->
    <!-- <div class="p-mb-2">
    <a class="layout-menu-button" href="#" @click="onMenuButtonClick">
            <i class="pi pi-bars"></i>
        </a>
      <div class="p-grid" style="margin: 0">

      <div class="p-col maxwidth">
        <img width="90" src="../public/assets/layout/images/logo_199.png" />
      </div>
      <div class="p-col">
        <div id="system-name">
          ระบบฐานข้อมูลสารสนเทศภูมิศาสตร์และระบบสารสนเทศการบริหาร
        </div>
        <div id="system-name" class="line">
          เพื่อการป้องกันและบรรเทาสาธารณภัย
        </div>
        <div id="system-name-org" class="p-mt-1">
          สำนักป้องกันและบรรเทาสาธารณภัย กรุงเทพมหานคร (สปภ. กทม.) : เวอร์ชั่น 2.4.1
        </div>
      </div>
        <div class="p-grid p-jc-end p-mt-2 p-mr-3 phone">
          <img width="26" height="26" :src="require('../public/assets/layout/images/ic_phone.png')" />
          <div id="system-name" class="p-ml-2">สายด่วน 199</div>
        </div>
    </div>
  </div> -->
</template>

<script>
import EventBus from './event-bus';

export default {
    props: {
        topbarMenuActive: Boolean,
        horizontal: Boolean,
        activeTopbarItem: String
    },
    data() {
        return {
            collapsedImage: false,
            icon: '',
            style: '',
            active: true,
            loginModal: false,
            username: '',
            password: '',
            fullname: '',
            position: '',
            error_username: false,
            error_password: false,
            checkStatusLogin: '',
            login_success: false,
            login_failed: false,

            suggestionModal: false,
            suggest_name: '',
            suggest_email_phone: '',
            suggest_topic: '',
            suggest_detail: '',
            error_suggest_name: false,
            error_suggest_email_phone: false,
            error_suggest_email_format: false,
            error_suggest_phone_format: false,
            error_suggest_topic: false,
            error_suggest_detail: false,
            model: [],

            displayConfirmationCloseModal: false,

            suggest_topic_options: [
                { id: 'ปัญหาการใช้งานของระบบ', name: 'ปัญหาการใช้งานของระบบ' },
                { id: 'ปัญหาข้อมูลทั่วไป', name: 'ปัญหาข้อมูลทั่วไป' }
            ],
            selectedType: { id: 'mail', name: 'อีเมล' }
        };
    },
    watch: {
        loginModal(val) {
            if (val == false) {
                this.clearData();
            }
        },
        checkStatusLogin(val) {
            if (val == 'failed login') {
                this.login_failed = true;
            } else {
                this.$fire({
                    title: 'เข้าสู่ระบบสำเร็จ',
                    text: 'ยินดีต้อนรับ',
                    type: 'success',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
                
                // เก็บข้อมูลลง localStorage
                localStorage.setItem('username', val.user_username);
                localStorage.setItem('session', val.user_fullname);
                
                // Decode token เพื่อดึงข้อมูล
                const token = localStorage.getItem('token');
                if (token) {
                    const decodedToken = this.decodeJWT(token);
                    if (decodedToken && decodedToken != 'failed login') {
                        this.login_success = true;
                        this.fullname = decodedToken.user_fullname;
                        this.position = decodedToken.organize_name;
                    }
                }
                
                // ปิด modal
                this.loginModal = false;
                
                // Emit event เพื่อบอก component อื่นๆ ว่า login สำเร็จแล้ว
                EventBus.$emit('user-logged-in');
                
                // Refresh หน้าจอเพื่ออัพเดทสถานะการ login
                location.reload();
            }
        },

        suggestionModal(val) {
            if (val == false) {
                if (this.suggest_name != '' && this.suggest_email_phone != '' && this.suggest_topic != '' && this.suggest_detail != '') {
                    this.displayConfirmationCloseModal = true;
                } else {
                    this.clearData();
                }
            }
        },

        displayConfirmationCloseModal(val) {
            if (val == true) {
                this.suggestionModal = true;
            }
        },

        suggest_email_phone(val) {
            if (val == '') {
                this.error_suggest_email_format = false;
            }
        },

        selectedType(val) {
            console.log('Select ' + val.id);
            this.suggest_email_phone = '';
        }
    },

    created() {
        const token = localStorage.getItem('token');
        if (token) {
            const decodedToken = this.decodeJWT(token);
            var check = decodedToken;
            if (check != null && decodedToken != 'failed login') {
                this.login_success = true;
                this.fullname = decodedToken.user_fullname;
                this.position = decodedToken.organize_name;
            } else {
                this.login_success = false;
                this.fullname = '';
                this.position = '';
            }
        }
    },
    mounted() {
        if (localStorage.getItem('session') != null) {
            this.collapsedImage = true;
            this.icon = 'pi pi-chevron-down';
            this.style = 'height:0px';
        } else {
            this.collapsedImage = false;
            this.icon = 'pi pi-chevron-up';
            this.style = '';
        }
        
        // Listen event จาก router เพื่อเปิด login modal
        EventBus.$on('show-login-modal-from-route', this.showLoginModal);
    },
    beforeDestroy() {
        // Remove event listener เมื่อ component ถูก destroy
        EventBus.$off('show-login-modal-from-route', this.showLoginModal);
    },
    methods: {
        showLoginModal() {
            this.loginModal = true;
        },
        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                console.error('Failed to decode JWT token:', error);
                return null;
            }
        },

        onMenuButtonClick(event) {
            this.$emit('menubutton-click', event);
        },
        onTopbarMenuButtonClick(event) {
            this.$emit('topbar-menubutton-click', event);
        },
        // changeIcon() {
        //   console.log(this.collapsedImage);
        //   if (this.collapsedImage == true) {
        //     this.icon = "pi pi-chevron-down";
        //     this.style = "height:0px";
        //   } else {
        //     this.icon = "pi pi-chevron-up";
        //     this.style = "";
        //   }
        // },

        acceptNumber() {
            var x = this.suggest_email_phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.suggest_email_phone = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },

        closeAllModal() {
            console.log('Close and don`t save data');
            this.suggestionModal = false;
            this.displayConfirmationCloseModal = false;
            this.clearData();
        },

        toggle(event) {
            this.$refs.op.toggle(event);
        },
        onMenuItemClick(event) {
            this.$emit('menuitem-click', event);
            if (localStorage.getItem('session') == null && event.item.label == 'ข้อเสนอแนะ') {
                this.suggestionModal = true;
            } else {
                console.log('admin level');
            }
        },
        onRootMenuItemClick(event) {
            this.$emit('root-menuitem-click', event);
        },

        async checkLogin() {
            if (this.username == '' || this.password == '') {
                if (this.username == '') {
                    this.error_username = true;
                }
                if (this.password == '') {
                    this.error_password = true;
                }
            } else {
                try {
                    const response = await this.axios.post(`${this.$url_service}/get/login`, {
                        body: {
                            username: this.username,
                            password: this.password
                        }
                    });
                    
                    this.checkStatusLogin = response.data.data;
                    console.log(' checkLogin() response.data.data =', response.data.data);
                    
                    if (this.checkStatusLogin === 'failed login') {
                        this.login_failed = true;
                    } else {
                        // เก็บ JWT token และ expiration time ลง localStorage
                        const token = response.data.token;
                        const expiresAt = new Date(Date.now() + 6 * 60 * 60 * 1000).toISOString(); // 6 ชั่วโมง
                        
                        localStorage.setItem('token', token);
                        localStorage.setItem('token_exp', expiresAt);
                        localStorage.setItem('data', JSON.stringify(response.data.data));
                    }
                } catch (error) {
                    console.error('Login failed:', error);
                    this.login_failed = true;
                }
            }
        },

        async checkSuggestion() {
            if (this.suggest_name == '' || this.suggest_email_phone == '' || this.suggest_topic == '' || this.suggest_detail == '') {
                if (this.suggest_name == '') {
                    this.error_suggest_name = true;
                }
                if (this.suggest_email_phone == '') {
                    this.error_suggest_email_phone = true;
                }
                if (this.suggest_topic == '') {
                    this.error_suggest_topic = true;
                }
                if (this.suggest_detail == '') {
                    this.error_suggest_detail = true;
                }
            } else {
                var check;
                if (this.selectedType.id == 'mail') {
                    var re =
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    check = re.test(this.suggest_email_phone);
                    console.log('Email validate : ' + check);
                }

                if (check == false) {
                    this.error_suggest_email_format = true;
                } else {
                    const receive = new Date();
                    const ye1 = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(receive);
                    const mo1 = new Intl.DateTimeFormat('en', {
                        month: '2-digit'
                    }).format(receive);
                    const da1 = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(receive);
                    const receivedate = `${ye1}-${mo1}-${da1}`;

                    let result = await this.axios
                        .post(`${this.$url_service}/get/suggestion`, {
                            body: {
                                topic: 'add-suggestion',
                                date: receivedate,
                                name: this.suggest_name,
                                contact: this.suggest_email_phone,
                                stopic: this.suggest_topic.id,
                                detail: this.suggest_detail
                            }
                        })
                        .then((resp) => {
                            return resp;
                        });
                    if (result) {
                        this.suggestionModal = false;
                        // this.$toast.add({
                        //   severity: "success",
                        //   summary: "เพิ่มข้อเสนอแนะสำเร็จ",
                        //   detail: "สำหรับผู้ใช้ทั่วไป",
                        //   life: 3000,
                        // });

                        this.$fire({
                            title: 'เพิ่มข้อเสนอแนะสำเร็จ',
                            text: 'สำหรับผู้ใช้ทั่วไป',
                            type: 'success',
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                        this.clearData();
                    } else {
                        // this.$toast.add({
                        //   severity: "danger",
                        //   summary: "เพิ่มข้อเสนอแนะไม่สำเร็จ",
                        //   detail: "มีข้อผิดพลาด",
                        //   life: 3000,
                        // });

                        this.$fire({
                            title: 'มีข้อผิดพลาด',
                            text: 'เพิ่มข้อเสนอแนะไม่สำเร็จ',
                            type: 'error',
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                    }
                }
            }
        },

        clearData() {
            this.username = '';
            this.password = '';
            this.login_failed = false;
            this.error_username = false;
            this.error_password = false;

            this.suggest_name = '';
            this.suggest_email_phone = '';
            this.suggest_topic = '';
            this.suggest_detail = '';
            this.selectedType = { id: 'mail', name: 'อีเมล' };
            this.error_suggest_name = false;
            this.error_suggest_email_phone = false;
            this.error_suggest_topic = false;
            this.error_suggest_detail = false;
        },

        logout() {
            localStorage.removeItem('session');
            localStorage.removeItem('data');
            this.$router.push('/statistic-disaster');
            location.reload();
        }
    },
    computed: {}
};
</script>
<style scoped>
#system-name {
    color: white;
    font-size: 16px;
}
#system-name-org {
    color: white;
    font-size: 14px;
}
/*  Doe แก้ไข Head 3/3 */
#system-nameclass {
    width: 34.5rem;
}

@media screen and (max-width: 420px) {
    #head_name_menu {
        visibility: visible !important;
        display: flex !important;
        color: white;
    }
    #system-name {
        display: none;
    }
    #system-name-org {
        color: white;
        font-size: 11px;
    }
    #login-texts {
        color: white;
        font-size: 14px;
    }
}
#head_name_menu {
    display: none;
    /* visibility: hidden; */
}
@media screen and (max-width: 523px) {
    #system-nameclass {
        width: 25rem;
    }
}

@media screen and (max-width: 455px) {
    #system-nameclass {
        width: 21.875rem;
    }
}

.LoginBar_ {
    margin-top: -1rem;
}
@media screen and (max-width: 1200px) {
    #Login_bar {
        display: flex;
        justify-content: center;
        align-items: center;
        /* background-color: blue; */
    }
    .LoginBar_ {
        margin-bottom: auto;
    }
}

@media screen and (max-width: 420px) {
    .layout-topbar-menu {
        right: 0;
    }

    #Login_bar {
        display: flex;
        justify-content: center;
        align-items: center;
        /* background-color: blue; */
    }
    .LoginBar_ {
        margin-top: 0;
    }
    #system-nameclass {
        width: 17rem;
    }
}
/*  Doe แก้ไข Head 3/3 จบ*/
.maxwidth {
    max-width: max-content;
}

.line {
    padding-bottom: 3px;
    border-bottom-style: solid;
    border-bottom-width: 2.5px;
    width: fit-content;
}

/* phone */

.layout-menu-button {
    display: none;
    width: 45px;
    color: #fff;
    float: right;
    margin-top: 14px;
    text-align: center;
}

.p-mt-3 {
    margin-top: -1rem !important;
}

@media screen and (max-width: 991px) {
    /* .phone {
 display: none;
} */

    .layout-menu-button {
        display: block;
    }
}

/* .pi {
    font-size: 10rem;
} */

.layout-topbar .layout-topbar-menu > li.user-profile.active-topmenuitem > ul {
    display: block;
    z-index: 9999;
}

.layout-wrapper.layout-fullwidth .layout-topbar,
.layout-wrapper.layout-fullwidth .layout-menu-container {
    padding: 0 9px;
}

.login-text {
    color: rgb(255, 255, 255);
    margin-left: auto;
    font-size: 16px;
}

.menuAll {
    font-size: 25px;
}
</style>
